import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { MobileBottomNav } from './MobileBottomNav'
import { ToastContainer } from '@/components/ui/Toast'
import { ReminderAlert } from '@/components/ui/ReminderAlert'
import { HelpButton } from '@/components/ui/HelpButton'
import { ChatWidget } from '@/components/ui/ChatWidget'
import { useUIStore } from '@/store/uiStore'
import { IdleLogoutGuard } from '@/components/layout/IdleLogoutGuard'
import { cn } from '@/utils/cn'

export function AppShell() {
  const { loadSidebarState, isSidebarMini } = useUIStore()

  useEffect(() => {
    loadSidebarState()
  }, [loadSidebarState])

  return (
    <div className="flex h-screen overflow-hidden app-shell">
      {/* Desktop sidebar (hidden on mobile — the bottom nav + More drawer
          handle navigation there) */}
      <Sidebar />

      {/* Main content area */}
      <div className={cn("flex flex-col flex-1 min-w-0 overflow-hidden transition-[margin] duration-200 ease-in-out", isSidebarMini ? "lg:ml-[64px]" : "lg:ml-[220px]")}>
        <Topbar />
        <main className="flex-1 overflow-auto flex flex-col pb-16 lg:pb-0">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom nav */}
      <MobileBottomNav />

      {/* Toast notifications */}
      <ToastContainer />

      {/* Global 20-minute reminders for meetings & tasks */}
      <ReminderAlert />

      {/* Help & Support floating button */}
      <HelpButton />

      {/* AI Chat Assistant */}
      <ChatWidget />

      {/* Auto sign-out after 20 min of inactivity, with a 1-min warning modal */}
      <IdleLogoutGuard />
    </div>
  )
}

export default AppShell
